module.exports = __webpack_public_path__ + "img/pic-coin@3x.6fa5508b.png";